import type DiscountCalculations from '../../../types/DiscountCalculations';
import request from '../request';

export type RequestData = Partial<{
  roomCount: number;

  totalAmount: number; // required only when voucherify is being used
  propertyId: string; // required only when voucherify is being used
  language: string; // required only when voucherify is being used
  accountId: string; // required only when voucherify is being used and user in logged in

  couponIds: number[];
  discountId: number;
  zenkokuId: number;

  discountCodes: string[]; // for voucherify coupon codes
  promotionIds: string[]; // for voucherify campaigns

  guestPerRooms: {
    adultCount: number;
    seniorElementarySchoolChildCount: number;
    juniorElementarySchoolChildCount: number;
    infantWithMealCount: number;
    infantWithFutonCount: number;
    infantWithMealAndFutonCount: number;
    infantWithoutMealAndFutonCount: number;
  }[];
  plans: Partial<{
    date: string;
    planCode: string;
    planRates: Partial<{
      availabilityStatus: string;
      rateEffectiveDate: string;
      rateExpireDate: string;
      guestRates: Partial<{
        guestType: string;
        guestCount: number;
        guestRateTaxIncl: number;
        guestRateType: string;
        roomPricingType: string;
      }>[];
      total: Partial<{
        currencyCode: string;
        amountAfterTax: number;
      }>;
    }>[];
  }>[];
  affiliate_id?: string;
}>;

const calculateDiscounts = async (data: RequestData) => {
  const discounts = await request<DiscountCalculations>({
    url: `${process.env.NEXT_PUBLIC_BFF_URL}/bookings/discounts`,
    method: 'POST',
    data,
  });

  return discounts;
};

export default calculateDiscounts;
